import { brand } from "../theme";

export const PLAYABLE_GAME_ID = "6aacf55485adb3207f93e7a9";

export const GameInteraction = {
  CLICKABLE: "clickable",
  DISABLED: "disabled",
  FAKE_SIGN_IN: "fake_sign_in",
  COMING_SOON: "coming_soon",
} as const;

export type GameInteractionType =
  (typeof GameInteraction)[keyof typeof GameInteraction];

export const GAME_ROOMS = [
  {
    id: PLAYABLE_GAME_ID,
    code: "LOTTO5",
    image: "/assets/game-v6.webp",
    nameKey: "dashboard_game_live_lotto",
    detailKey: "dashboard_game_live_lotto_detail",
    badgeKey: "status_open",
    badgeColor: brand.success,
    href: "/game/bet",
    available: true,
    interaction: GameInteraction.CLICKABLE,
  },
  {
    code: "SPEED_DRAW",
    image: "/assets/game-v5.webp",
    nameKey: "dashboard_game_speed_draw",
    detailKey: "dashboard_game_speed_draw_detail",
    badgeKey: "dashboard_game_fast",
    badgeColor: brand.gold,
    href: "/game/bet",
    available: false,
    interaction: GameInteraction.FAKE_SIGN_IN,
  },
  {
    code: "TREASURE_BONUS",
    image: "/assets/game-v4.webp",
    nameKey: "dashboard_game_treasure_bonus",
    detailKey: "dashboard_game_treasure_bonus_detail",
    badgeKey: "dashboard_game_bonus",
    badgeColor: brand.warning,
    href: "/game/bet",
    available: false,
    interaction: GameInteraction.FAKE_SIGN_IN,
  },
  {
    code: "FORTUNE_SPIN",
    image: "/assets/game-v3.webp",
    nameKey: "dashboard_game_fortune_spin",
    detailKey: "dashboard_game_fortune_spin_detail",
    badgeKey: "dashboard_game_new",
    badgeColor: brand.gold,
    href: "/game/bet",
    available: false,
    interaction: GameInteraction.FAKE_SIGN_IN,
  },
  {
    code: "POOLBALL",
    image: "/assets/game-v2.webp",
    nameKey: "dashboard_game_poolball",
    detailKey: "dashboard_game_poolball_detail",
    badgeKey: "dashboard_game_vip",
    badgeColor: brand.goldSoft,
    href: "/game/bet",
    available: false,
    interaction: GameInteraction.COMING_SOON,
  },
  {
    code: "SUPER_CARS",
    image: "/assets/game-v1.webp",
    nameKey: "dashboard_game_super_cars",
    detailKey: "dashboard_game_super_cars_detail",
    badgeKey: "dashboard_game_hot",
    badgeColor: brand.warning,
    href: "/game/bet",
    available: false,
    interaction: GameInteraction.COMING_SOON,
  },
];

export type GameRoom = (typeof GAME_ROOMS)[number];
